import React from 'react';
import { motion } from 'framer-motion';
import { useMotionPreferences } from '../../hooks/useMotionPreferences';
import { springSnappy } from '../../utils/motion';
type GlowButtonProps = {
  children: React.ReactNode;
  className?: string;
  href?: string;
  onClick?: () => void;
  ariaLabel?: string;
  /** Lift distance on hover, in px. */
  lift?: number;
};
export function GlowButton({
  children,
  className = '',
  href,
  onClick,
  ariaLabel,
  lift = 3
}: GlowButtonProps) {
  const {
    reduced
  } = useMotionPreferences();
  const interactions = {
    whileHover: reduced ? {
      opacity: 0.9
    } : {
      scale: 1.04,
      y: -lift
    },
    whileTap: reduced ? {
      opacity: 0.8
    } : {
      scale: 0.965,
      y: 0
    },
    transition: springSnappy,
    style: {
      willChange: 'transform'
    } as React.CSSProperties
  };
  if (href) {
    return <motion.a href={href} target={href.startsWith('http') ? '_blank' : undefined} rel={href.startsWith('http') ? 'noopener noreferrer' : undefined} aria-label={ariaLabel} className={className} {...interactions} data-id="element-127" data-mp="11tagkqt9e7xq">
        {children}
      </motion.a>;
  }
  return <motion.button type="button" onClick={onClick} aria-label={ariaLabel} className={className} {...interactions} data-id="element-128" data-mp="1jx7rfp3j5cql">
      {children}
    </motion.button>;
}